// 组件
import ChildrenTable from "./subpage/childrenTable";
// 常量
import { columnsProps } from "../SuperTable/interface";
import { CHILDREN_SHOW_OPTION_KEY, DEFAULT_CHILDREN_DATA_KEY, DEFAULT_ROW_KEY, DEFAULT_SHOW_LENGTH, MergeChildrenTableProps, MergeTableColumns, baseChildrenTableProps } from "./interface";

/**
 * 生成合并行表格的配置
 * @param columns 外部传入列配置
 * @param dataSource 表格数据
 * @returns 
 */
export function setMergeColumns(
  columns: MergeTableColumns[],
  childrenDataKey: string = DEFAULT_CHILDREN_DATA_KEY,
  otherProps?: Partial<MergeChildrenTableProps>,
): columnsProps[] {
  const newColumns: columnsProps[] = [];
  columns.forEach(item => {
    const { children, onCell, ...restItem } = item;
    if (Array.isArray(children) && children.length) {
      children.forEach((childrenItem, index) => {
        if (index === 0) {
          const childrenGroup = childrenItem.children;
          const newColumn: columnsProps = {
            ...childrenItem,
            dataIndex: `${childrenDataKey}-${index}`,
            className: 'merge-table-column',
          };
          // 子表第一列分组
          if (Array.isArray(childrenGroup) && childrenGroup.length) {
            const newChildrenGroup = childrenGroup.map((childrenGroupItem, itemIndex) => {
              if (itemIndex === 0) {
                return {
                  ...childrenGroupItem,
                  className: 'merge-table-column',
                  render: (_: any, record: any, index: any) => {
                    const value = record[childrenDataKey];
                    if (Array.isArray(value) && value.length) {
                      const dataSource = [...value];
                      if (otherProps?.defaultShowLength === false) {
                        return (
                          <ChildrenTable
                            {...otherProps}
                            columns={children}
                            dataSource={dataSource}
                          />
                        );
                      }
                      const defaultShowLength = otherProps?.defaultShowLength || DEFAULT_SHOW_LENGTH;
                      const childrenRowKey = otherProps?.childrenRowKey || DEFAULT_ROW_KEY;
                      if (value.length > defaultShowLength) {
                        const operationRecord: any = {
                          [CHILDREN_SHOW_OPTION_KEY]: true,
                        };
                        if (typeof childrenRowKey === 'string') {
                          operationRecord[childrenRowKey] = `${CHILDREN_SHOW_OPTION_KEY}-${index}`;
                        }
                        dataSource.push(operationRecord);
                      }
                      return (
                        <ChildrenTable
                          {...otherProps}
                          columns={children}
                          dataSource={dataSource}
                        />
                      );
                    }
                    return otherProps?.emptyChildren;
                  },
                  onCell: () => ({
                    colSpan: calculateColumnsLength(children),
                  }),
                };
              }
              return {
                ...childrenGroupItem,
                onCell: () => ({
                  colSpan: 0,
                }),
              };
            });
            newColumn.children = newChildrenGroup;
          } else {
            newColumn.render = (_, record, index) => {
              const value = record[childrenDataKey];
              if (Array.isArray(value) && value.length) {
                const dataSource = [...value];
                if (otherProps?.defaultShowLength === false) {
                  return (
                    <ChildrenTable
                      {...otherProps}
                      columns={children}
                      dataSource={dataSource}
                    />
                  );
                }
                const defaultShowLength = otherProps?.defaultShowLength || DEFAULT_SHOW_LENGTH;
                const childrenRowKey = otherProps?.childrenRowKey || DEFAULT_ROW_KEY;
                if (value.length > defaultShowLength) {
                  const operationRecord: any = {
                    [CHILDREN_SHOW_OPTION_KEY]: true,
                  };
                  if (typeof childrenRowKey === 'string') {
                    operationRecord[childrenRowKey] = `${CHILDREN_SHOW_OPTION_KEY}-${index}`;
                  }
                  dataSource.push(operationRecord);
                }
                return (
                  <ChildrenTable
                    {...otherProps}
                    columns={children}
                    dataSource={dataSource}
                  />
                );
              }
              return otherProps?.emptyChildren;
            };
            newColumn.onCell = () => ({
              colSpan: calculateColumnsLength(children),
            });
          }
          newColumns.push(newColumn);
        } else {
          newColumns.push({
            ...childrenItem,
            children: childrenItem.children?.map?.(v => ({
              ...v,
              onCell: () => ({
                colSpan: 0,
              }),
            })),
            onCell: () => ({
              colSpan: 0,
            }),
          });
        }
      });
    } else {
      newColumns.push(restItem);
    }
  });
  return newColumns;
}
/**
 * 计算子表总列数
 * @param columns 子表列配置
 */
export function calculateColumnsLength(columns: MergeTableColumns[]): number {
  let length = 0;
  columns.forEach(item => {
    length += (item.children?.length || 1);
  });
  return length;
}
